import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Vue from 'vue';
import loading from './index.vue';
import variables from '@/assets/styles/variables.scss';
import { lang } from '@/lang';
var textMap = new Map([['zh', '加载中'], ['en', 'Loading'], ['th', 'กำลังดาวน์โหลด']]);
var options = {
  hide: true,
  text: textMap.get(lang.currentLang),
  themeColor: variables.theme
};
var Load = Vue.extend(loading);
var node = new Load({
  data: function data() {
    return options;
  }
});
node.$mount();
export default {
  open: function open(el) {
    var parent = el || document.body;
    if (!parent.load) {
      parent.load = node;
      parent.appendChild(node.$el);
    }
    node.hide = true;
  },
  close: function close() {
    options.hide = false;
  }
};